document.addEventListener('DOMContentLoaded', function (event) {
  if (window.location.pathname === '/fr/homepage-va') {
    const img = document.querySelector('.hero-animation-translate div:nth-child(1) img');
    if (window.matchMedia('(min-width: 1024px)').matches) {
      img.style.marginLeft = '30px';
    } else {
      img.style.marginLeft = '20px';
    }
    document.querySelector('.hero-animation-translate div:nth-child(1)').style.zIndex = 1
    document.querySelector('.hero-animation-translate div:nth-last-child(1) img').style.mixBlendMode = 'normal';
  }
  if ($('.hero-section').length) {
    if ($('.intro-overlay').length) {
      $('.intro-overlay').click(function () {
        $('.intro-text').toggleClass('intro-mode');
        $(this).toggleClass('intro-mode');
      });
    }

    const ImagesContainer = document.querySelectorAll('.hero-animation-translate img');
    ImagesContainer.forEach(element => {
      element.style.transform = 'translate(0)';
      element.style.opacity = 1;
    });

    const cardsContainer = document.querySelectorAll('.hero-animation-cards img');
    cardsContainer.forEach((element, index) => {
      if (index === 0) {
        element.style.transform = 'translateY(100px)';
      } else if (index === 1) {
        element.style.transform = 'translateY(0)';
      } else {
        element.style.transform = 'translateY(-100px)';
      }
    });
  }
});
